import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import Loader from "../../Components/Loader";
import CustomButton from "../../Components/CustomButton";
import BackButton from "../../Components/BackButton";
import MainHeader from "../../Components/MainHeader/MainHeader";
import ConsentCheckbox from "../../Components/ConsentCheckbox";
import EmailInput from "../../Components/EmailInput";
import PasswordInput from "../../Components/PasswordInput";
import Input from "../../Components/Input";

import useRegistration from "../../store/RegistrationStore";

import CountryCode from "../../Components/CountryCode";

import "./style.scss";

const Registration = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [params] = useSearchParams();
  const queryParams = Object.fromEntries([...params]);
  const isSSO = params.get("isSSO");

  const {
    firstName,
    lastName,
    phoneNumber,
    register_password,
    register_email,
    providerRegistrationSteps,
    showTermsError,
    emailNeedsVerification,

    changeFirstName,
    changeLastName,
    changePhoneNumber,
    changeRegister_password,
    changeRegister_email,
    registerValidation,
    changeRegisterValidation,
    changeProviderRegistrationSteps,
    setTermsAggred,
    setShowTermsError,
    registrationLoader,
    successLoader,
    FetchRegister,
    handleExternalRegister,
    setEmailNeedsVerification,
  } = useRegistration();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "register-email") {
      changeRegister_email(value);
    }
    if (name === "register-password") {
      changeRegister_password(value);
    }
    if (name === "register-name") {
      changeFirstName(value);
    }
    if (name === "register-last-name") {
      changeLastName(value);
    }
  };

  useEffect(() => {
    if (queryParams.email) {
      changeRegister_email(queryParams.email);
    }

    if (queryParams.phoneNumber) {
      changePhoneNumber(queryParams.phoneNumber);
    }
  }, [queryParams]);

  const registrationButton = async (e) => {
    e.preventDefault();
    if (isSSO) {
      handleExternalRegister();
    } else {
      FetchRegister();
    }
  };

  const handleCheckboxChange = (cheked) => {
    setTermsAggred(cheked);
    setShowTermsError(!cheked);
  };

  return (
    <div className="registration">
      <MainHeader />
      <form
        className="registration-form"
        onSubmit={(e) => {
          registrationButton(e);
        }}
      >
        <h2 className="registration-haeder">{t("provide_following_info")}</h2>

        <EmailInput
          name="register-email"
          email={register_email}
          label={t("input_label_email")}
          onChange={handleInputChange}
          setEmailNeedsVerification={setEmailNeedsVerification}
          required
          showStatusIcon
          needsVerification={emailNeedsVerification}
          disabled={!!state?.email || !!queryParams.email}
        />

        <div id="registration-countrycode">
          <CountryCode
            phone={phoneNumber}
            changePhone={changePhoneNumber}
            disability={!!queryParams.phoneNumber}
          />
        </div>
        {!isSSO && (
          <PasswordInput
            name="register-password"
            label={t("input_label_create_password")}
            value={register_password}
            onChange={handleInputChange}
            required
          />
        )}

        <Input
          name="register-name"
          autoComplete="name"
          label={t("input_label_first_name")}
          value={firstName}
          onChange={handleInputChange}
        />

        <Input
          name="register-last-name"
          autoComplete="last name"
          label={t("input_label_last_name")}
          value={lastName}
          onChange={handleInputChange}
        />
        <ConsentCheckbox
          onConsentChange={handleCheckboxChange}
          hasError={showTermsError}
        />
        <div className="regiter-buttons-container">
          <BackButton
            onClick={(e) => {
              changeRegisterValidation("");

              if (providerRegistrationSteps === 2) {
                changeProviderRegistrationSteps(1);
                return;
              }
              navigate(-1);
            }}
          />
          <CustomButton fullWidth type="submit">
            {t("sign_up")}
          </CustomButton>
        </div>

        {!showTermsError && !!registerValidation && (
          <h3>{registerValidation}</h3>
        )}
      </form>

      {registrationLoader ? <Loader /> : null}

      {successLoader ? (
        <div className="successfully-registered">
          <h1>{t("regitration_success")}</h1>
        </div>
      ) : null}
    </div>
  );
};

export default Registration;
